module.exports = __webpack_public_path__ + "img/KK饭局.37e6184f.png";